import { useDispatch } from 'react-redux';
import { logout } from '../redux/authSlice';

export const useLogout = () => {
  const dispatch = useDispatch();

  const performLogout = async () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("masterClass");
    localStorage.removeItem("is_admin_impersonation");
    localStorage.removeItem("admin_user_id");

    dispatch(logout());

    return Promise.resolve();
  };

  return { performLogout };
};
